import React, {useEffect} from 'react'
import { useTranslation } from '../../core/translation/useTranslation';

import './notificationMessages.css'
import { notificationStatus } from '../../core/constats';
import {toast} from "react-toastify";

export const NotificationMessage = ({ message, type = notificationStatus.Error }) => {
  const t = useTranslation()
    useEffect(() => {
        setTimeout(() => {
            toast.dismiss()
        },2500)
    },[])

  return (
    <div className="error__message__content">
      <div className="error__message__img__content">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.3 33.3" fill="#222423">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path className="cls-1"
                    d="M16.65,33.3A16.65,16.65,0,1,1,33.3,16.65,16.67,16.67,0,0,1,16.65,33.3Zm0-30.3A13.65,13.65,0,1,0,30.3,16.65,13.66,13.66,0,0,0,16.65,3Z"/>
              <path className="cls-1"
                    d="M19.14,16.65,23,12.85a1.76,1.76,0,0,0,.51-1.25A1.74,1.74,0,0,0,23,10.36a1.79,1.79,0,0,0-2.49,0l-3.81,3.8-3.8-3.8a1.79,1.79,0,0,0-2.49,0,1.75,1.75,0,0,0-.52,1.24,1.77,1.77,0,0,0,.52,1.25l3.8,3.8-3.8,3.81a1.75,1.75,0,0,0-.52,1.24A1.79,1.79,0,0,0,10.36,23a1.81,1.81,0,0,0,2.49,0l3.8-3.81L20.46,23a1.74,1.74,0,0,0,1.24.51,1.74,1.74,0,0,0,1.76-1.76A1.74,1.74,0,0,0,23,20.46Z"/>
            </g>
          </g>
        </svg>
      </div>
      <div className={`${type}__message__message__content`}>
        {t(message)}
      </div>
    </div>
  );
}
